module.exports = __webpack_public_path__ + "img/logobA.cb362160.png";